import React from "react";
import { formatMoney } from 'accounting-js';
import { CurrencyEurIcon, CurrencyDollarIcon, CurrencyGbpIcon, CurrencyJpyIcon, } from "@phosphor-icons/react";

const FormatEuro = ({
    amount = 0,
    currency = "EUR",
    size,
}) => {
    return (<span className="format-euro">
        {currency === "EUR" && <CurrencyEurIcon size={size} />}
        {currency === "USD" && <CurrencyDollarIcon size={size} />}
        {currency === "GBP" && <CurrencyGbpIcon size={size} />}
        {currency === "JPY" && <CurrencyJpyIcon size={size} />}
        {formatMoney(amount, { symbol: "", format: "%s %v", decimal: ",", thousand: ".", })}</span>);
};

export default FormatEuro;